export default __webpack_public_path__ + "static/media/Necklace of Relentless Bellicosity.da8c54b4.jpg";